import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { Card } from 'react-bootstrap';
import { dashboardStores } from '../Dashboard/stores/DashboardStores';
import { observer } from 'mobx-react';
import {
    getDailyChatMessages,
} from '../../api/dashboard/dashboard';
class ChartChatMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                chart: {
                    id: "basic-bar"
                },
                xaxis: {
                    categories: []
                }
            },
            series: [
                {
                    name: "series-1",
                    data: []
                }
            ]
        };
    }


    componentDidMount = async () => {
        const result = await getDailyChatMessages();
        const dataArray = result.dataArray || [];
        var xaxisCategories = [];
        for (let index = 0; index < dataArray.length; index++) {
            const element = dataArray[index];
            xaxisCategories.push(element.name);
        }
        var xaxisData = [];
        for (let index = 0; index < dataArray.length; index++) {
            const element = dataArray[index];
            xaxisData.push(element.totalMessages);
        }
        const dailyChatMessagesChart = {
            options: {
                chart: {
                    id: "basic-bar"
                },
                xaxis: {
                    categories: xaxisCategories
                },
                fill: {
                    colors: ['#2ecc71']
                }
            },
            series: [
                {
                    name: "Daily chat messages ",
                    data: xaxisData
                }
            ]
        }
        this.setState({
            options: dailyChatMessagesChart.options,
            series: dailyChatMessagesChart.series
        })
    };

    render() {
        return (
            <Card style={{ width: '100%' }}>
                <Card.Header as="h5">Biểu đồ</Card.Header>
                <Card.Body>
                    <Card.Title>Số lượng "Chat message" hằng ngày</Card.Title>
                    <Card.Text>
                        <Chart
                            options={this.state.options}
                            series={this.state.series}
                            type="bar"
                            width='100%'

                        />
                    </Card.Text>
                </Card.Body>
            </Card>
        );
    }
}

export default observer(ChartChatMessage);